var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "panel granary-right-panel" }, [
      _c("div", { staticClass: "chart-box" }, [
        _c("div", { staticClass: "item-top" }, [
          _c("div", { staticClass: "item-title" }, [
            _c("span", { staticClass: "num" }, [_vm._v("37530")]),
            _vm._v("(个)"),
          ]),
          _c("div", [_vm._v("渔业户")]),
        ]),
        _c("div", { staticClass: "item-center k2" }, [
          _c("div", { staticClass: "item-title" }, [
            _c("span", { staticClass: "num" }, [_vm._v("62")]),
            _vm._v("(个)"),
          ]),
          _c("div", [_vm._v("渔业村")]),
        ]),
        _c("div", { staticClass: "item-center k3" }, [
          _c("div", { staticClass: "item-title" }, [
            _c("span", { staticClass: "num" }, [_vm._v("192631")]),
            _vm._v("(人)"),
          ]),
          _c("div", [_vm._v("渔业人口")]),
        ]),
        _c("div", { staticClass: "item-btm k4" }, [
          _c("div", { staticClass: "item-title" }, [
            _c("span", { staticClass: "num" }, [_vm._v("9")]),
            _vm._v("(个)"),
          ]),
          _c("div", [_vm._v("渔业乡")]),
        ]),
        _c("div", { staticClass: "item-btm k5" }, [
          _c("div", { staticClass: "item-title" }, [
            _c("span", { staticClass: "num" }, [_vm._v("134691")]),
            _vm._v("(人)"),
          ]),
          _c("div", [_vm._v("渔业从业人员")]),
        ]),
        _c("img", {
          staticClass: "rk-cent",
          attrs: {
            src: require("@/assets/images/granary/yy/人口.png"),
            alt: "",
          },
        }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }